export default {
  namespaced: true,
  state: {
    types: []
  },
  mutations: {
    /**
     * [setTypes description]
     * @param {[type]} state   [description]
     * @param {[type]} payload [description]
     */
    types(state, payload) {
      state.types = payload;
    },
  },
  getters: {
    /**
     * [types description]
     * @param  {[type]} state [description]
     * @return {[type]}       [description]
     */
    types(state) {
      return state.types
    }
  },
  actions: {
    /**
     * [apply description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} payload         [description]
     * @return {[type]}                 [description]
     */
    applyMagrow({commit, getters}, payload) {
      return this._vm.$http
        .post('membership/magrow/apply', payload)
          .then(response => response.data)
    },
    /**
     * [apply description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @param  {[type]} payload         [description]
     * @return {[type]}                 [description]
     */
    apply({commit, getters}, payload) {
      return this._vm.$http
        .post('membership/mmc/apply', payload)
          .then(response => response.data)
    },
    /**
     * [get_types description]
     * @param  {[type]} options.commit  [description]
     * @param  {[type]} options.getters [description]
     * @return {[type]}                 [description]
     */
    get_types({commit, getters}) {
      if(getters['types'].length > 0) {
        return Promise.resolve(getters['types'])
      }
      return this._vm.$http
        .get('membership')
        .then(response => {
          commit('types', response.data)
          return response.data
        })
    }
  }
}